<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import List from '../../extend/List.vue';
import JobCardDelivery from '../../components/JobCardDelivery.vue';
@Component()
export default class MyDeliveredResume extends Vue.extend(List) {
  userId = this.$store.state.user.info.id
  options = {
    url: `/portal/delivery`,
    methods: "GET"
  }
  componentName = JobCardDelivery
  showState = true
  created() {
    if (!this.$store.state.user.info) {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>